/*
 index

 Główny plik strony  
 Renderowanie w miejscu wyznaconym rzez element root
 
 historia: 
  04-2019 JW - start
  04-05-2019 - rezygnacja z redux-react-hook
*/

import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import { Provider } from 'react-redux'

//import { StoreContext } from 'redux-react-hook'; // https://github.com/facebookincubator/redux-react-hook
import { MuiThemeProvider } from '@material-ui/core/styles';

import { BrowserRouter, Route, Link } from 'react-router-dom';

import App from './App';
import { store, Actions } from './appredux';

import theme from './themes';

import i18n from './cfg/i18n' // (needs to be bundled ;))
import { I18nextProvider } from 'react-i18next';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { sendErrorLog } from "./app/common/helpers";
import CONFIG from "./cfg/config";

import moment from "moment";
import MomentUtils from "@date-io/moment";
import { setLocale } from "./app/common/localeHelpers";

const Loader = () => <div>loading...</div>;

window.onerror = async (msg, url, line, col, error) => {
  // Note that col & error are new to the HTML 5 spec and may not be 
  // supported in every browser.  It worked for me in Chrome.
  var extra = !col ? '' : '\ncolumn: ' + col;
  extra += !error ? '' : '\nerror: ' + error;

  const log = "Error: " + msg + "\nurl: " + url + "\nline: " + line + extra

  // You can view the information in an alert to see things working like this:
  console.error(log);

  // Report this error via ajax so you can keep track
  //       of what pages have JS issues
  await sendErrorLog( '0', '-1', (log.length > 50 ? log.substring(0, 50) : log))
  await store.dispatch(Actions.pageState.addFcmLogMessage(log.length > 50 ? log.substring(0, 50) : log, 2))

  var suppressErrorAlert = true;
  // If you return true, then error alerts (like in older versions of 
  // Internet Explorer) will be suppressed.
  return suppressErrorAlert;
};

ReactDOM.render(
  <I18nextProvider i18n={i18n as any}>
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <Suspense fallback={<Loader />}>
            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={setLocale("pl")}> {/*utils={DateFnsUtils}*/}
              <App />
            </MuiPickersUtilsProvider>
          </Suspense>
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  </I18nextProvider>
  ,
  document.getElementById('root')
);
{/* zakomentować, route odkomentować */ }
{/* <Route exact path="/" component={App} />
          <Route path="/plus" component={Plus} />
          <Route path="/minus" component={Minus} />          */}
/*
import * as serviceWorker from "./serviceWorker"
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
*/